<div class="aic-root">

  <!-- ── FAB ─────────────────────────────────────────────────── -->
  <button class="aic-fab" [class.open]="isOpen()" (click)="toggle()" type="button" title="Finance 360 AI">
    <span class="aic-fab-rings"></span>
    @if (isOpen()) {
      <svg class="aic-fab-icon" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
    } @else {
      <svg class="aic-fab-icon" viewBox="0 0 24 24"><path d="M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4l-4 3-4-3H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm7 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/></svg>
    }
    @if (!isOpen() && unreadCount > 0) {
      <span class="aic-fab-badge">{{ unreadCount }}</span>
    }
  </button>

  <!-- ── Panel ─────────────────────────────────────────────── -->
  @if (isOpen()) {
  <div class="aic-panel">

    <!-- Header -->
    <div class="aic-header">
      <div class="aic-header-brand">
        <div class="aic-brand-dot"></div>
        <div>
          <div class="aic-brand-name">Finance 360 AI</div>
          <div class="aic-brand-sub">Powered by Azure OpenAI GPT-4o</div>
        </div>
      </div>
      <div class="aic-header-actions">
        <button class="aic-hbtn" (click)="newChat()" title="New chat" type="button">
          <svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
        </button>
        <button class="aic-hbtn" [class.active]="panelView() === 'history'" (click)="showHistory()" title="Chat history" type="button">
          <svg viewBox="0 0 24 24"><path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>
        </button>
        <button class="aic-hbtn" (click)="close()" title="Close" type="button">
          <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </button>
      </div>
    </div>

    <!-- ── CHAT VIEW ──────────────────────────────────────── -->
    @if (panelView() === 'chat') {
    <div class="aic-body">
      <div class="aic-messages">

        <!-- Welcome -->
        @if (showSuggestions) {
        <div class="aic-welcome">
          <div class="aic-welcome-glyph">✦</div>
          <p class="aic-welcome-title">Ask anything about your Finance 360 data</p>
          <p class="aic-welcome-hint">I can query anomalies, billing data, costs, reports, and more.</p>
          <div class="aic-suggestions">
            @for (q of suggestions; track q) {
              <button class="aic-chip" (click)="sendSuggestion(q)" type="button">{{ q }}</button>
            }
          </div>
        </div>
        }

        <!-- Messages -->
        @for (msg of messages(); track trackById($index, msg)) {
          <div class="aic-msg-row" [class.user]="msg.role === 'user'" [class.assistant]="msg.role === 'assistant'">

            @if (msg.role === 'assistant') {
              <div class="aic-avatar">✦</div>
            }

            <div class="aic-bubble" [class.error]="msg.is_error === 'true'">
              <p class="aic-bubble-text">{{ msg.content }}</p>

              <!-- DB badge -->
              @if (msg.db_used) {
                <span class="aic-db-badge">{{ msg.db_used }}</span>
              }

              <!-- SQL toggle -->
              @if (msg.sql_query) {
                <button class="aic-sql-btn" (click)="toggleSql(msg.id)" type="button">
                  <svg viewBox="0 0 24 24"><path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/></svg>
                  {{ expandedSql() === msg.id ? 'Hide SQL' : 'View SQL' }}
                </button>
                @if (expandedSql() === msg.id) {
                  <pre class="aic-sql">{{ msg.sql_query }}</pre>
                }
              }

              <!-- Data table -->
              @if (msg.columns?.length && msg.rows?.length) {
                <div class="aic-table-meta">
                  <span>{{ msg.row_count }} row{{ msg.row_count === 1 ? '' : 's' }}</span>
                  @if (msg.db_used) { <span>· {{ msg.db_used }} DB</span> }
                </div>
                <div class="aic-table-wrap">
                  <table class="aic-table">
                    <thead>
                      <tr>@for (col of msg.columns; track col) { <th>{{ col }}</th> }</tr>
                    </thead>
                    <tbody>
                      @for (row of msg.rows; track trackByIdx($index)) {
                        <tr>@for (cell of row; track trackByIdx($index)) { <td [title]="cell ?? ''">{{ cell ?? '—' }}</td> }</tr>
                      }
                    </tbody>
                  </table>
                </div>
              }

              @if (msg.row_count === 0 && msg.sql_query && msg.is_error !== 'true') {
                <div class="aic-empty">No results found for this query.</div>
              }

              <span class="aic-ts">{{ relativeTime(msg.created_at) }}</span>
            </div>
          </div>
        }

        <!-- Typing indicator -->
        @if (isSending()) {
          <div class="aic-msg-row assistant">
            <div class="aic-avatar">✦</div>
            <div class="aic-bubble typing">
              <span></span><span></span><span></span>
            </div>
          </div>
        }

        <div #msgEnd></div>
      </div>

      <!-- Input -->
      <div class="aic-input-wrap">
        <textarea
          #inputEl
          class="aic-input"
          rows="1"
          placeholder="Ask about your data..."
          [value]="inputText()"
          (input)="inputText.set($any($event.target).value)"
          (keydown)="onKeyDown($event)"
          [disabled]="isSending()"
          autocomplete="off"
        ></textarea>
        <button
          class="aic-send"
          (click)="send()"
          [disabled]="isSending() || !inputText().trim()"
          type="button"
        >
          @if (isSending()) {
            <span class="aic-send-spin"></span>
          } @else {
            <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
          }
        </button>
      </div>
    </div>
    }

    <!-- ── HISTORY VIEW ───────────────────────────────────── -->
    @if (panelView() === 'history') {
    <div class="aic-body">
      <div class="aic-history-header">
        <button class="aic-back" (click)="showChat()" type="button">
          <svg viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
          Back to chat
        </button>
        <span class="aic-history-count">{{ sessions().length }} conversation{{ sessions().length === 1 ? '' : 's' }}</span>
      </div>

      @if (isLoadingSessions()) {
        <div class="aic-loading">
          <span class="aic-spin-ring"></span>
          <span>Loading history…</span>
        </div>
      }

      @if (!isLoadingSessions() && sessions().length === 0) {
        <div class="aic-empty-history">
          <div class="aic-empty-icon">💬</div>
          <p>No conversations yet.</p>
          <button class="aic-new-btn" (click)="newChat()" type="button">Start a conversation</button>
        </div>
      }

      <div class="aic-session-list">
        @for (s of sessions(); track s.id) {
          <div
            class="aic-session-item"
            [class.active]="s.id === activeSessionId()"
            (click)="openSession(s)"
          >
            <div class="aic-session-icon">
              <svg viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
            </div>
            <div class="aic-session-meta">
              <div class="aic-session-title">{{ s.title || 'New conversation' }}</div>
              <div class="aic-session-info">
                <span>{{ relativeTime(s.updated_at) }}</span>
                @if (s.message_count) {
                  <span>· {{ s.message_count / 2 | number:'1.0-0' }} turn{{ s.message_count > 2 ? 's' : '' }}</span>
                }
              </div>
            </div>
            <button class="aic-del-btn" (click)="deleteSession(s, $event)" title="Delete" type="button">
              <svg viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
            </button>
          </div>
        }
      </div>
    </div>
    }

  </div>
  }

</div>